import { useEffect } from "react";

function usePreventBFCache() {
	useEffect(() => {
		const noop = () => {};
		window.addEventListener("unload", noop);
		return () => window.removeEventListener("unload", noop);
	}, []);
}

export default usePreventBFCache;
